import app from "./firebase";

const auth = app.auth();
if(process.env.NODE_ENV === "development") {
    //TODO: do this programatically
    // auth.useEmulator("http://localhost:9099");
}

export default auth;